module.exports = __webpack_public_path__ + "img/62.7.Chla.d3041ebf.png";